import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { UseAlert } from '../../../presentation/hook/AlertHook';
import { UseLoader } from '../../../presentation/hook/LoaderHook';

import { PaginationType } from '../../contract/Pagination';

import { PrivateRoutes } from '../../../main/constant/RouteConstant';
import MessageConstant from '../../../main/constant/MessageConstant';

import { ProfessionalUseCase } from '../../../data/useCase/ProfessionalUseCase';

import ListProfessionalPage from '../../../presentation/page/listProfessional/ListProfessionalPage';

import { InputsSearchProfessional } from '../../../presentation/page/listProfessional/ListProfessionalPageType';
import { HttpStatusCodeEnum } from '../../enums/HttpStatusCodeEnum';
import { UseAuth } from '../../../presentation/hook/AuthHook';
import { ProfilesConstant } from '../../../main/constant/ProfilesConstant';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';

/**
 * ListProfessionalPageDomain - regra de negocio de listagem profissionais
 * @constructor
 */
export const ListProfessionalPageDomain: React.FC = () => {
  /**
   * Perfil de acesso
   */
  const PROFILE_ADMIN = ProfilesConstant.admin;
  const PROFILE_RECEPCIONISTA = ProfilesConstant.receptionist;

  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * dados do usuario logado no localstorage
   */
  const { loggedUserData } = UseAuth();
  const userRoles = loggedUserData?.roles || [];
  const ROLE_ADMIN = PROFILE_ADMIN;
  const roleIsAdmin = userRoles.includes(ROLE_ADMIN);
  const ROLE_RECEPCIONISTA = PROFILE_RECEPCIONISTA;
  const roleIsRecepcionista = userRoles.includes(ROLE_RECEPCIONISTA);
  /**
   * loading
   */
  const { setLoad } = UseLoader();

  let PAGE = 0;
  let PAGE_SIZE = 15;
  let STATUS = 'Ativos';

  /**
   * endpoint
   */
  const ENDPOINT_PROFESSIONAL = EndpointsConstant.professional;

  /**
   * navegacao da url
   */
  let navigate = useNavigate();

  /**
   * model
   */
  const [list, setList] = useState<[]>([]);

  /**
   * paginacao
   */
  const [pagination, setPagination] = useState<PaginationType | null>(null);

  /**
   * add
   */
  const add = () => {
    navigate(PrivateRoutes.ADD_PROFESSIONAL);
  };

  /**
   * getList
   */
  const getList = async () => {
    setLoad(true);
    setPagination(null);
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/?page=${PAGE}&pageSize=${PAGE_SIZE}&status=${STATUS}`)
      .Get()
      .then((response: any) => {
        if (roleIsAdmin || roleIsRecepcionista) {
          setList(response.body.items);
        } else {
          setList(response.body.items.filter((item: any) => item.profileDescription !== PROFILE_RECEPCIONISTA));
        }
        if (response.body.totalPages > 1) {
          setPagination({
            pageIndex: response.body.pageIndex,
            pageSize: response.body.pageSize,
            totalCount: response.body.totalCount,
            totalPages: response.body.totalPages,
            hasPreviousPage: response.body.hasPreviousPage,
            hasNextPage: response.body.hasNextPage,
            onClickItem: handleClickPagination,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
    setLoad(false);
  };

  /**
   * remove
   * @param id
   */
  const remove = async (id: number) => {
    setLoad(true);
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/${id}`)
      .Delete()
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });

    await getList();
    setLoad(false);
  };

  /**
   * toggle
   * @param id
   */
  const toggle = async (id: number) => {
    setLoad(true);
    STATUS = 'Ativos';
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/${id}/reactivate`)
      .Put()
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          if (response.statusCode === HttpStatusCodeEnum.ok) {
            showAlert({
              show: true,
              content: MessageConstant.sucesso.criar,
              color: 'success',
              time: 2000,
            });
          } else {
            response.body.forEach((item: any) => {
              showAlert({
                show: true,
                content: item.errorMessage,
                color: 'warning',
                time: 2000,
              });
            });
          }
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });

    navigate(PrivateRoutes.LIST_PROFESSIONAL);

    await getList();
    setLoad(false);
  };

  /**
   * edit
   * @param id
   */
  const edit = (id: number) => {
    navigate(`${PrivateRoutes.ADD_PROFESSIONAL}/${id}`);
  };

  /**
   * searchProfessional
   * @param params
   */
  const searchProfessional = async (params: InputsSearchProfessional) => {
    STATUS = params.status ?? 'Ativos';
    setLoad(true);
    setPagination(null);
    await new ProfessionalUseCase(`${ENDPOINT_PROFESSIONAL}/?page=${PAGE}&pageSize=${PAGE_SIZE}&name=${params.nome}&status=${params.status ?? 'Ativos'}`)
      .Get()
      .then((response) => {
        if (roleIsAdmin || roleIsRecepcionista) {
          setList(response.body.items);
        } else {
          setList(response.body.items.filter((item: any) => item.profileDescription !== PROFILE_RECEPCIONISTA));
        }
        if (response.body.totalPages > 1) {
          setPagination({
            pageIndex: response.body.pageIndex,
            pageSize: response.body.pageSize,
            totalCount: response.body.totalCount,
            totalPages: response.body.totalPages,
            hasPreviousPage: response.body.hasPreviousPage,
            hasNextPage: response.body.hasNextPage,
            onClickItem: handleClickPagination,
          });
        }
      })
      .catch((error) => {
        console.error('ERRO: ', error);
        if (error.response.status === HttpStatusCodeEnum.badRequest) {
          error.response.data.forEach((item: any) => {
            showAlert({
              show: true,
              content: item.errorMessage,
              color: 'warning',
              time: 2000,
            });
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      });
    setLoad(false);
  };

  /**
   * handleClickPagination
   * @param id
   */
  const handleClickPagination = async (id: number) => {
    PAGE = id;
    await getList();
  };

  /**
   *
   */
  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <ListProfessionalPage add={add} list={list} remove={remove} edit={edit} search={searchProfessional} pagination={pagination} toggle={toggle} />
    </>
  );
};
